import { render, staticRenderFns } from "./ShowBalance.vue?vue&type=template&id=7453f09e&"
import script from "./ShowBalance.vue?vue&type=script&lang=js&"
export * from "./ShowBalance.vue?vue&type=script&lang=js&"
import style0 from "./ShowBalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports